import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

interface Props {
  infoText: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupInfoButton',
  props: {
    infoText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, { "open-on-hover": "" }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, {
        density: "compact",
        flat: ""
      }), {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("mdi-information-variant-circle-outline", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 16)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "info-card" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "info", {}, () => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.infoText), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})